// The Fittin mark (from /brand/fittin-icon.svg) as a dark squircle.
// No masks/ids needed: the "lens" ellipse is painted in the squircle colour,
// so any number of instances can live on one page.
export default function FittinMark({
  size = 24,
  bg = "#0A0A0A",
  fg = "#FFFFFF",
  lens = null, // colour of the cut-out; defaults to the squircle colour
  className = "",
  testid,
}) {
  return (
    <svg
      data-testid={testid}
      width={size}
      height={size * (463 / 489)}
      viewBox="85 234 489 463"
      role="img"
      aria-label="Fittin"
      className={className}
    >
      <rect x="85" y="234" width="489" height="463" rx="104" ry="104" fill={bg} />
      <g fill={fg}>
        <g transform="matrix(0.489,0,0,0.463,85.489,-554.027)">
          <path d="M161.789,2319C161.789,2153.43 296.214,2019 461.789,2019C627.363,2019 761.789,2153.43 761.789,2319C761.789,2480.82 633.397,2612.88 473,2618.8L473,2619L161.789,2619L161.789,2319Z" />
        </g>
        <g transform="matrix(0.489,0,0,0.463,-509.624,-1118.66)">
          <path d="M1657.79,3239.23L1657.79,3186.76C1657.79,3178.82 1660.95,3171.2 1666.57,3165.58C1672.18,3159.96 1679.8,3156.81 1687.75,3156.81C1761.32,3156.83 1950.2,3156.87 2023.71,3156.89C2040.23,3156.9 2053.63,3170.28 2053.65,3186.8C2053.76,3260.37 2054.05,3449.53 2054.16,3523.2C2054.18,3531.16 2051.03,3538.79 2045.41,3544.41C2039.79,3550.04 2032.16,3553.2 2024.21,3553.2L1978.43,3553.2C1978.67,3548.34 1978.79,3543.44 1978.79,3538.5C1978.79,3372.93 1844.36,3238.5 1678.79,3238.5C1671.74,3238.5 1664.74,3238.75 1657.79,3239.23Z" />
        </g>
      </g>
      <g transform="matrix(5.43333,0,0,5.80855,-4088.56,-4968.23)">
        <ellipse cx="825" cy="931.087" rx="27" ry="23.913" fill={lens || bg} />
      </g>
    </svg>
  );
}
